import { render } from "./ds-tip-prib-view.vue?vue&type=template&id=3f07048a&scoped=true"
import script from "./ds-tip-prib-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-tip-prib-view.vue?vue&type=script&setup=true&lang=js"

import "./ds-tip-prib-view.vue?vue&type=style&index=0&id=3f07048a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f07048a"],['__file',"src/views/tep/tep-nsi/ds-tip-prib-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f07048a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f07048a', __exports__)) {
    api.reload('3f07048a', __exports__)
  }
  
  module.hot.accept("./ds-tip-prib-view.vue?vue&type=template&id=3f07048a&scoped=true", () => {
    api.rerender('3f07048a', render)
  })

}


export default __exports__